import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=713aff62&scoped=true"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"
import style0 from "./ServicesList.vue?vue&type=style&index=0&id=713aff62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713aff62",
  null
  
)

export default component.exports